import config from '@/config'
import { httpClientPrivate } from '@/libs/httpClient'
import { useQuery } from '@tanstack/react-query'

export interface ContactStatusOption {
  code: string
  name: string
}

interface ContactStatusResponse {
  status: ContactStatusOption[]
}

const fetchFilterContactStatus = async (): Promise<ContactStatusOption[]> => {
  const response = await httpClientPrivate.get<ContactStatusResponse>(
    `${config.restUrl}/v1/backoffice/crash-detection/contact-status`,
  )
  return response.data.status
}

const useFilterContactStatus = () => {
  const queryKey = ['useFilterContactStatus']
  const queryFn = async () => fetchFilterContactStatus()
  const queryResult = useQuery({ queryKey, queryFn })

  return { ...queryResult }
}

export { fetchFilterContactStatus, useFilterContactStatus }
